var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.719,
    height: 20,
    viewBox: "0 0 15.719 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-54.798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.929,5.664a.585.585,0,0,0,.545-.8,3.717,3.717,0,0,0-3.442-2.324h-.719A3.111,3.111,0,0,0,63.282,0h-1.25A3.111,3.111,0,0,0,59,2.539h-.719a3.717,3.717,0,0,0-3.442,2.324.585.585,0,0,0,.545.8Zm-7.9-4.492h1.25a1.922,1.922,0,0,1,1.826,1.367h-4.9A1.922,1.922,0,0,1,62.032,1.172Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.852,186.531a1.764,1.764,0,0,0,1.753,1.633h7.817a1.764,1.764,0,0,0,1.753-1.633L103,175H90.031Zm7.264-8.4a.586.586,0,1,1,1.17.059l-.312,6.25a.586.586,0,0,1-1.17-.059Zm-3.819-.556a.586.586,0,0,1,.614.556l.313,6.25a.586.586,0,0,1-1.17.059l-.312-6.25A.586.586,0,0,1,94.3,177.579Z",
    transform: "translate(-33.857 -168.164)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.017bfabf.svg";
export { ForwardRef as ReactComponent };